import React, {useEffect, useState} from "react";
import {notification} from "antd";
import moment from "moment";
import {companyService} from "../../../../services";
import MainDataFields from "../../create-legal-entity/lithuania-legal-entity/steps/main-data-fields";
import GuarantorFields from "../../create-legal-entity/lithuania-legal-entity/steps/guarantor-fields";
import i18n from "../../../../i18n";

export default function EditLithuaniaLegalEntity({
    isActive = false,

    currentStep,
    setCurrentStep,

    legalEntityId,
    legalEntityData,

    setLoading,

    setStepsList,

    changeStepEvent,
    setChangeStepEvent,

    editLegalEntityEvent,
    setEditLegalEntityEvent,

    setIsShowParent
}) {
  const [fieldsErrors, setFieldsErrors] = useState({});

  const [mainDataFields, setMainDataFields] = useState({
    orgFormId: legalEntityData.OrgFormId,
    countryId: legalEntityData.CountryId,

    name: legalEntityData.Name,
    fullName: legalEntityData.FullName,
    firstName: legalEntityData.FirstName,
    secondName: legalEntityData.SecondName,
    patronymic: legalEntityData.Patronymic,
    email: legalEntityData.Email,
    phone: legalEntityData.Phone,
    bankName: legalEntityData.BankName,
    accountNumber: legalEntityData.AccountNumber,
    swift: legalEntityData.Swift,
    position: legalEntityData.PositionStr,
    registerNumber: legalEntityData.RegisterNumber,
    legalNumber: legalEntityData.LegalNumber,
    legalReason: legalEntityData.LegalReason,
    address: legalEntityData.Address,
    mailingAddress: legalEntityData.MailingAddress
  });

  const [guarantorFields, setGuarantorFields] = useState({
    guarantorFirstName: legalEntityData.GuarantorFirstName,
    guarantorSecondName: legalEntityData.GuarantorSecondName,
    guarantorPatronymic: legalEntityData.GuarantorPatronymic,
    guarantorPassportSerial: legalEntityData.GuarantorPassportSerial,
    guarantorPassportNumber: legalEntityData.GuarantorPassportNumber,
    guarantorAddressFact: legalEntityData.GuarantorAddressFact,
    guarantorCountry: legalEntityData.GuarantorCountry,
    guarantorPhone: legalEntityData.GuarantorPhone,
    guarantorEmail: legalEntityData.GuarantorEmail,
  });

  const getFieldErrors = (fieldName) => {
    return typeof fieldsErrors[fieldName] !== "undefined"
        ? fieldsErrors[fieldName].reduce((fieldErrors, error) => {
          return fieldErrors + "; " + error;
        })
        : null;
  };

  useEffect(() => {
    if (isActive) {
      if (mainDataFields.orgFormId === 13) {
        setStepsList([
          'Pagrindiniai duomenys',
        ]);
      } else {
        setStepsList([
          'Pagrindiniai duomenys',
          'Garantas',
        ]);
      }
    }
  }, [isActive]);

  useEffect(() => {
    if (changeStepEvent) {
      if (changeStepEvent === 'next') {
        nextStep();
      } else if (changeStepEvent === 'previous') {
        previousStep();
      }

      setChangeStepEvent('');
    }
  }, [changeStepEvent]);

  useEffect(() => {
    if (editLegalEntityEvent) {
      setLoading(true);

      let data = Object.assign(mainDataFields, guarantorFields);
      companyService.editForeignLegalEntity(data, legalEntityId)
          .then(response => {
            if (response.code === 400) {
              notification.error({
                message: i18n.t('components.notification.titles.editLegalEntityData'),
                description: response.message,
              });
              setFieldsErrors(response.errors);
            } else {
              notification.success({
                message: i18n.t('components.notification.titles.editLegalEntityData'),
                description: response.message,
              });

              setIsShowParent(false);
            }

            setLoading(false);
            setEditLegalEntityEvent(false);
          })
          .catch(errMsg => {
            notification.error({
              message: i18n.t('components.notification.titles.createLegalEntity'),
              description: errMsg,
            });

            setLoading(false);
            setEditLegalEntityEvent(false)
          });
    }
  }, [editLegalEntityEvent]);

  const nextStep = () => {
    let stepData = (currentStep) => {
      let stepFields = {
        1: mainDataFields,
        2: guarantorFields
      };

      // Баг. Без этого виесто stepFields undefiend
      console.log(stepFields, currentStep, mainDataFields.orgFormId);

      return stepFields[currentStep];
    };

    setLoading(true);

    companyService
        .createForeignLegalEntityValidateStepData(stepData(currentStep), currentStep, mainDataFields.orgFormId, mainDataFields.countryId, true)
        .then(response => {
          setLoading(false);

          if (response.status === 'success') {
            if (currentStep < 5) {
              if ((currentStep + 1) === 4 && mainDataFields.orgFormId === 1) {
                setCurrentStep(currentStep + 2);
              } else {
                setCurrentStep(currentStep + 1);
              }
              setFieldsErrors([]);
            }
          } else {
            setFieldsErrors(response.errors);
          }
        })
        .catch(error => {
          setLoading(false);
          notification.error({
            message: i18n.t('components.notification.titles.createForeignLegalEntityValidateStepData'),
            description: error,
          });
        });
  };

  const previousStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    } else {
      setCurrentStep(0);
    }
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return (
            <MainDataFields
                setFields={setMainDataFields}
                stepFields={mainDataFields}
                getFieldErrors={getFieldErrors}
                edit={true}
            />
        );
      case 2:
        return (
            <GuarantorFields
                setFields={setGuarantorFields}
                stepFields={guarantorFields}
                getFieldErrors={getFieldErrors}
                edit={true}
            />
        );
      default:
        return <div />;
    }
  };

  return (
      <div>
        {renderCurrentStep()}
      </div>
  );
}
